module.exports = "<app-dashboard\r\n  [projectIds]=\"ids\"\r\n  [summary]=\"summary$ | async\"\r\n  [terms]=\"terms$ | async\">\r\n</app-dashboard>\r\n"